<template>
  <div>
    <div class="main_box">
      <div>
        <!--操作栏-->
        <el-form @submit.native.prevent :inline="true">
          <el-form-item>
            <el-form-item label="选择集中器UID：">
              <el-select
                v-model="searchForm.concentratorId"
                placeholder="请选择"
                :filterable="true"
                :clearable="true"
                @change="changeConcentrator"
                @clear="clearConcentrator"
              >
                <el-option
                  v-for="(item, index) in concentratorList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="插座号：">
              <el-select
                v-model="searchForm.socketId"
                placeholder="请选择"
                :filterable="true"
                :clearable="true"
                @change="changeSocket"
              >
                <el-option
                  v-for="(item, index) in socketInfo"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button icon="el-icon-plus" @click="save(null)" type="primary">新建集中器</el-button>
      <el-button type="primary" @click="exportData">批量导出二维码</el-button>
    </div>
    <div class="main_box_table">
      <el-table
        :data="dataList"
        row-key="id"
        :tree-props="{ children: 'deviceVoList' }"
        border
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="concentratorUid" label="集中器UID"></el-table-column>
        <el-table-column prop="socketNo" label="插座号"></el-table-column>
        <el-table-column prop="chargingCycles" label="生成二维码">
          <template slot-scope="scope">
            <el-image  v-if="scope.row.qrCode" class="imgReview" :src="scope.row.qrCode" :preview-src-list="[scope.row.qrCode]" ></el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="350px" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.parentId&&!scope.row.qrCode" @click="getQrcode(scope.row)" slot="reference" type="text" style="color:#0091FF;">
                <span class="iconfont icon-erweima" style="color:#0091FF;"></span>生成二维码
            </el-button>
            <el-button v-if="!scope.row.parentId" type="text" style="color:#0091FF;" @click="addSocket(scope.row,true)"
                       icon="el-icon-circle-plus-outline">新增插座
            </el-button>
            <el-button v-if="!scope.row.parentId" type="text" @click="save(scope.row)" icon="el-icon-edit">编辑
            </el-button>
            <el-button v-if="scope.row.parentId" type="text" @click="addSocket(scope.row)" icon="el-icon-edit">编辑
            </el-button>
            <el-button type="text" style="color: #FA6400;" @click="deleteRole(scope.row)" icon="el-icon-delete">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex-r-e">
        <el-pagination
          v-show="total > 0"
          background=""
          layout="prev, pager, next, sizes, total, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="dialogTitle == 0 ? '添加集中器' : '编辑集中器'"
      :visible.sync="dialogVisible"
      append-to-body
      width="430px"
      @close="closeDialogVisible"
    >
      <el-form
        :model="currentData"
        ref="currentData"
        :rules="rules"
        label-width="140px"
        class="demo-ruleForm"

      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="集中器UID：" prop="concentratorUid">
              <el-input placeholder="请输入" v-model="currentData.concentratorUid"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogVisible" class="cancel-btn"
        >取 消
        </el-button
        >
        <el-button type="primary" @click="submitRole('currentData')"
        >确 定
        </el-button
        >
      </div>
    </el-dialog>
    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="dialogTitle == 0 ? '添加插座' : '编辑插座'"
      :visible.sync="addSocketDialogVisible"
      append-to-body
      width="430px"
      @close="closeSocketDialogVisible"
    >
      <el-form
        :model="socketData"
        ref="socketData"
        :rules="rules1"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="插座号：" prop="socketNo">
              <el-input max="250" min="1" placeholder="请输入" v-model="socketData.socketNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeSocketDialogVisible" class="cancel-btn"
        >取 消
        </el-button
        >
        <el-button type="primary" @click="submitSocket('socketData')"
        >确 定
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api";

var _self;
export default {
  data() {
    return {
      //分页
      pageNum: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        concentratorId: "",
        socketId: "",
        concentratorUid: "",
        socketNo: ""
      },
      dataList: [],
      //弹窗
      dialogVisible: false,
      dialogTitle: 0, //新建为0，编辑为1,查看为2
      currentData: {
        concentratorUid: ""
      },
      socketData: {
        concentratorUid: "",
        socketNo: "",
        parentId: ""
      },
      addSocketDialogVisible: false,
      rules: {
        concentratorUid: [
          {
            required: true,
            message: "集中器UID不能为空！",
            trigger: "blur"
          }
        ]
      },
      rules1: {
        socketNo: [
          {
            required: true,
            message: "插座号不能为空！",
            trigger: "blur"
          }
        ]
      },
      concentratorList: [],
      socketInfo: []
    };
  },
  created() {
    _self = this;
  },
  mounted() {
    _self.loadData();
    _self.getConcentratorList();
  },
  methods: {
    clearConcentrator() {
      _self.searchForm.concentratorId = "";
      _self.searchForm.socketId = "";
      _self.loadData();
    },
    dateChange() {
      if (_self.searchForm.applyDate == null) _self.searchForm.applyDate = [];
    },
    // 每页多少条
    handleSizeChange(val) {
      _self.pageSize = val;
      _self.loadData();
    },
    // 当前页
    handleCurrentChange(val) {
      _self.pageNum = val;
      _self.loadData();
    },
    loadData() {
      let param = {
        pageNum: _self.pageNum - 1,
        pageSize: _self.pageSize,
        ..._self.searchForm
      };
      api.deviceAPI
        .getPageInfo(param)
        .then(res => {
          if (res.status == 200) {
            if (res.data.content.length == 0 && res.data.total != 0) {
              _self.pageNum -= 1;
              _self.loadData();
              return;
            }
            _self.dataList = res.data.content;
            _self.total = res.data.total;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    reset() {
      _self.searchForm = _self.$options.data().searchForm;
      _self.loadData();
    },
    //生成二维码
    async getQrcode(row) {
      let res = await api.deviceAPI.generatorQrCode({
        id: row.id,
        socketNo: row.socketNo,
        concentratorUid: row.concentratorUid
      });
      if(res.status == 200){
        this.loadData()
      }
      console.log(res);
    },
    //添加
    save(row) {
      if (row) {
        //编辑
        _self.dialogTitle = 1;
        _self.currentData = JSON.parse(JSON.stringify(row));
      } else {
        //添加
        _self.dialogTitle = 0;
        _self.currentData = this.$options.data().currentData;
      }
      _self.dialogVisible = true;
    },
    submitRole() {
      this.$refs["currentData"].validate(valid => {
        if (valid) {
          if (_self.dialogTitle == 1) {
            api.deviceAPI.updateGenerator({
                id: _self.currentData.id,
                concentratorUid: _self.currentData.concentratorUid
            })
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.dialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            api.deviceAPI.createGenerator(_self.currentData)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.dialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSocket(row, isAdd) {
      if (!isAdd) {
        //编辑
        _self.dialogTitle = 1;
        _self.socketData = JSON.parse(JSON.stringify(row));
      } else {
        //添加
        _self.dialogTitle = 0;
        _self.socketData.concentratorUid = row.concentratorUid;
        _self.socketData.parentId = row.id;
      }
      _self.addSocketDialogVisible = true;
    },
    submitSocket() {
      this.$refs["socketData"].validate(valid => {
        if (valid) {
          if (_self.dialogTitle == 1) {
            api.deviceAPI.updateGenerator({
              id: _self.socketData.id,
              socketNo: _self.socketData.socketNo
            })
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.addSocketDialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            api.deviceAPI.createGenerator(_self.socketData)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.addSocketDialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeDialogVisible() {
      _self.currentData = this.$options.data().currentData;
      _self.dialogVisible = false;
    },
    closeSocketDialogVisible() {
      _self.socketData = this.$options.data().socketData;
      _self.addSocketDialogVisible = false;
    },
    deleteRole(row) {
      _self
        .$confirm("此操作将永久删除此项, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          row.deleteFlg = "1";
          api.deviceAPI
            .deleteGenerator({ id: row.id })
            .then(res => {
              if (res.status == 200) {
                this.$message.success("操作成功");
                _self.loadData();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
        });
    },
    async getConcentratorList() {
      let res = await api.deviceAPI.getConcentratorInfo();
      if (res.status == 200) {
        _self.concentratorList = res.data.map(it => {
          return {
            value: it.id,
            label: it.concentratorUid
          };
        });
      }
      console.log(res);
    },
    async changeConcentrator() {
      _self.concentratorList.forEach(it => {
        if (it.value == _self.searchForm.concentratorId) {
          _self.searchForm.concentratorUid = it.label;
        }
      });
      let res = await api.deviceAPI.getSocketInfo({ id: _self.searchForm.concentratorId });
      if (res.status == 200) {
        _self.socketInfo = res.data.map(it => {
          return {
            value: it.id,
            label: it.socketNo
          };
        });
      }
      console.log(res, "3333333");
    },
    changeSocket() {
      _self.socketInfo.forEach(it => {
        if (it.value == _self.searchForm.socketId) {
          _self.searchForm.socketNo = it.label;
        }
      });
    },
    exportData() {
        api.deviceAPI.exportQrcode(_self.searchForm)
        .then(res => {
          let blob = new Blob([res], { type: "application/zip,charset=utf-8" });//此处必须添加
          let url = window.URL.createObjectURL(blob);
          const link = window.document.createElement("a"); // 创建a标签
          link.href = url;
          link.download = `二维码.zip`; // 重命名文件
          link.click();
          URL.revokeObjectURL(url); // 释放内存
        })
        .catch(error => {
          console.log(error);
        });
    },
  }
};
</script>
<style lang="scss" scoped>
.el-tree {
  border: 1px solid #D9D9D9 !important;
}
.imgReview{
  width: 60px;
  height: 60px;
}
</style>
